function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IvimeoCircle = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: "#1AB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.505 12.0409C25.4154 14.0056 24.0424 16.6971 21.3886 20.1128C18.6452 23.6802 16.3235 25.4646 14.4236 25.4646C13.2479 25.4646 12.2525 24.3784 11.4388 22.2047C10.8964 20.2127 10.3526 18.222 9.81019 16.2299C9.20674 14.0575 8.55918 12.97 7.86619 12.97C7.71565 12.97 7.18617 13.288 6.28165 13.9213L5.33301 12.6975C6.32837 11.8228 7.31076 10.9469 8.27757 10.0696C9.60645 8.9224 10.6031 8.31765 11.2688 8.25666C12.8391 8.10612 13.8059 9.18065 14.1693 11.4789C14.5612 13.9602 14.8324 15.5032 14.9843 16.1067C15.4372 18.1649 15.9355 19.1927 16.4792 19.1927C16.9023 19.1927 17.5369 18.5243 18.383 17.1903C19.2279 15.8549 19.6808 14.8388 19.7418 14.1419C19.8624 12.9895 19.4095 12.412 18.383 12.412C17.899 12.412 17.4006 12.5223 16.8893 12.7429C17.8808 9.4934 19.7755 7.91406 22.5734 8.0036C24.6472 8.0646 25.6244 9.41035 25.505 12.0409Z",
    fill: "white"
  }));
});